<template>
  <div id="app">
    <div id="nprogress-container" />
    <ald-loader v-if="$store.getters['ui/dataUI']('loader')" />
    <router-view />
  </div>
</template>

<script>
import InjectScriptMixin from 'mixins/InjectScriptMixin';

export default {
  name: 'AldAutomotive',

  mixins: [InjectScriptMixin],

  computed: {
    title() {
      return this.$store.getters['landing/getResourcesKey']('tag-html-title', 'description');
    },
    description() {
      return this.$store.getters['landing/getResourcesKey'](
        'tag-html-meta-description',
        'description'
      );
    }
  },

  mounted() {
    this.$cookiebot.consentBanner();
    // Hash Change evvent for modal with legals

    this.setTheme(this.$store.getters['ui/dataUI']('theme'));
    this.$store.watch(
      getters => getters.ui.theme,
      val => {
        this.setTheme(val);
      }
    );
  },

  methods: {
    setTheme(theme) {
      this.$el.parentElement.className = `theme-${theme}`;
    }
  },

  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: 'description',
          content: this.description
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
